import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    getAllEncounterType,
    pagingEncounterType,
    getEncounterTypeById,
    saveOrUpdateEncounterType,
    deleteEncounterType
} from 'app/services/EncounterTypeService';

import { EncounterType } from "app/common/Model/EncounterType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class EncounterTypeStore {
    listAllEncounterType = [];
    searchEncounterType = new SearchObject();
    pageEncounterType = null;
    selectedEncounterType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteEncounterType = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllEncounterType = () => {
        if (this.listAllEncounterType?.length === 0 || this.recentlyUpdated) {
            getAllEncounterType()
                .then(({ data }) => {
                    this.listAllEncounterType = data;
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu loại thăm khám có lỗi");
                })
        }
    }

    pagingEncounterType = () => {
        pagingEncounterType(this.searchEncounterType)
            .then(({ data }) => {
                this.pageEncounterType = data;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu loại thăm khám có lỗi");
            })
    }

    handleChangeFormSearch = (searchEncounterType) => {
        this.searchEncounterType = checkSearchObject(this.searchEncounterType, searchEncounterType);
        this.pagingEncounterType();
    }

    handleOpenFormCreateOrEdit = (encounterTypeId) => {
        if (Boolean(encounterTypeId)) {
            getEncounterTypeById(encounterTypeId)
                .then(({ data }) => {
                    this.selectedEncounterType = data;
                    this.openFormCreateOrEdit = true;
                }).catch(function (error) {
                    console.error(error);
                    toast.error("Lấy dữ liệu không thành công");
                });
        } else {
            this.selectedEncounterType = new EncounterType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveEncounterType = async (encounterType, { setSubmitting }) => {
        return await saveOrUpdateEncounterType(encounterType).then(() => {
            this.selectedEncounterType = null;
            toast.success("Lưu kiểu gặp mặt thành công!");
            this.pagingEncounterType();
            this.handleClosePopup();
            this.recentlyUpdated = true;
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu kiểu gặp mặt thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteEncounterType = (encounterType) => {
        this.selectedEncounterType = { id: encounterType?.id };
        this.openConfirmDeleteEncounterType = true;
    }

    handleConfirmDeleteEncounterType = () => deleteEncounterType(this.selectedEncounterType?.id)
        .then(() => {
            if (this.searchEncounterType?.pageIndex > 1 && this.pageEncounterType?.content?.length === 1) {
                this.searchEncounterType.pageIndex -= 1;
            }
            toast.success("Xóa kiểu gặp mặt thành công!");
            this.pagingEncounterType();
            this.handleClosePopup();
            this.recentlyUpdated = true;
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa kiểu gặp mặt thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteEncounterType = false;
    }

    resetStore = () => {
        this.searchEncounterType = new SearchObject();
        this.pageEncounterType = null;
        this.selectedEncounterType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteEncounterType = false;
    }
}